/* Package imports */
import { useEffect } from 'react';
import Routes from './routes/Routes';

/* Component imports */
import FeedbackModal from './components/FeedbackModal';
import { ToastContainer } from 'react-toastify';

/* Utility imports */
import store from './store/index';
import { setupAxiosInterceptors } from './utils/axiosInterceptors';

/* Style imports */
import './assets/scss/Saas.scss';
import 'react-toastify/dist/ReactToastify.css';

const App = (props) => {
  useEffect(() => {
    // Setup axios interceptors for token refresh and auto-logout
    setupAxiosInterceptors(store);
  }, []);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{
          fontSize: '0.875rem'
        }}
      />
      <FeedbackModal></FeedbackModal>
      <Routes></Routes>
    </>
  );
};

export default App;
